/* Romaccio - productpagina: foto's filteren op kleur + pasadvies naast Maat.

   Waarom dit bestaat: van de foto's bij een product is er maar een per kleur
   aan een variant gekoppeld. De rest hangt nergens aan vast, dus Shopify toont
   ze bij elke kleur. Een klant die Legergroen kiest, scrolt zo langs bruin en
   rood.

   HOE WE WETEN WELKE FOTO BIJ WELKE KLEUR HOORT. Drie bronnen:

   1. DE BESTANDSNAAM, het zekerst. Een deel van de foto's heet naar zijn
      kleur, meestal in het Engels: ...leather-jacket-brown-xs-1252768.jpg.
      Hieronder staat een lijstje Nederlands -> Engels, zodat Bruin die foto
      herkent. Samengestelde namen tellen mee: Koffiebruin kent zo ook
      "brown". De langste match wint, dus "light-brown" gaat voor "brown".
      Noemt een woord twee kleuren van hetzelfde product ("red" bij zowel Rood
      als Bordeaux), dan laten we dat woord vallen: liever niets dan een gok.

   2. DE POSITIE. Van elke kleur weet Shopify een foto zeker: de variantfoto.
      Een kleur bezit alles vanaf die foto tot aan de variantfoto van de
      volgende kleur; wat ervoor staat hoort bij de eerste kleur. Dat klopt bij
      de meeste producten.

   3. DE FOTO ZELF. We halen elke foto op 64 pixels breed op en tellen hoeveel
      pixels er van elke kleurtoon in het midden staan. Elke foto gaat naar de
      variantfoto met de meest gelijkende verdeling. Tellen in plaats van
      middelen is hier nodig: het gemiddelde van een zwarte jas met een
      lichtblauw hemd eronder komt uit op bruin, maar de verdeling verraadt dat
      het grootste deel zwart is.

   Twee en drie samen. Zegt de meting bij EEN enkele foto iets anders dan de
   positie, dan houden we het bij de positie: op een foto waar het kledingstuk
   klein in beeld staat - loafers tussen een spijkerbroek - telt de achtergrond
   zwaarder dan de schoen, en dan zit de meting ernaast. Zegt ze bij DRIE of
   meer foto's iets anders, dan is het geen toeval en kloppen de posities niet:
   bij de parka staan de zwarte foto's vóór het zwarte anker. Dan laten we de
   posities helemaal vallen.

   Lijkt een foto bijna evenveel op twee kleuren - een detailfoto van een rits,
   of wit naast crème - dan laten we haar los en blijft ze bij elke kleur
   staan. Liever een foto te veel dan de verkeerde.

   Nagemeten over 163 producten met een kleuroptie: 31 hebben maar een kleur,
   111 zijn volkomen regelmatig, 20 onregelmatig, 1 mist een anker.

   VANGNETTEN. Ontbreken de gegevens, mist een kleur zijn anker, of staan er
   twee kleuren op dezelfde positie, dan valt het terug op de oude alt-tekst
   methode. Levert die ook niets op, dan blijft gewoon alles staan. Zou een
   kleur nul foto's overhouden, dan toont hij alles. Er wordt dus nooit meer
   verborgen dan we zeker weten.

   Er wordt NIETS aan de productgegevens veranderd. Geen foto's herkoppelen,
   niets verplaatsen, niets verwijderen. Alleen verbergen in beeld.

   Let op het wachtmoment verderop: klik je een kleur aan, dan staat de nieuwe
   kleur meteen aangevinkt, maar haalt het thema de bijhorende foto's pas een
   kleine halve seconde later op. Filterden we in dat gaatje al, dan zag je even
   een verkeerde set voorbijkomen. Daarom wachten we tot de galerij echt
   vernieuwd is; dat herkennen we aan de bestandsnamen die erin staan.

   Door Claude gebouwd. Zie snippets/ai-css-productpagina.liquid om het uit te
   zetten. */

(function () {
  'use strict';

  var BEZIG = false;
  var KIJKER = null;
  var TIMER = null;
  var VORIGE_INHOUD = null;   /* welke foto's stonden er bij de vorige ronde */
  var VORIGE_KLEUR = null;    /* op welke kleur hebben we toen gefilterd */
  var VOORGELADEN = {};       /* welke kleuren we al opgehaald hebben */
  var WACHT_SINDS = null;     /* sinds wanneer wachten we op de nieuwe galerij */
  var BLOKKEN;                /* bestandsnaam -> kleur, of null */
  var STAAL = null;           /* bestandsnaam -> kleur, uit de foto's zelf */

  /* Nederlands -> wat er in de bestandsnamen staat. Alleen woorden die we ook
     echt zijn tegengekomen; bij twijfel liever niets toevoegen. */
  var WOORDEN = {
    'zwart': ['black'],
    'wit': ['white'],
    'gebrokenwit': ['off-white', 'offwhite', 'ecru'],
    'ecru': ['ecru', 'off-white'],
    'creme': ['cream', 'ivory'],
    'beige': ['beige'],
    'camel': ['camel'],
    'taupe': ['taupe'],
    'zand': ['sand'],
    'bruin': ['brown'],
    'lichtbruin': ['light-brown', 'lightbrown'],
    'donkerbruin': ['dark-brown', 'darkbrown'],
    'cognac': ['cognac', 'tan'],
    'mokka': ['mocha'],
    'chocolade': ['chocolate', 'choco'],
    'koffie': ['coffee'],
    'grijs': ['grey', 'gray'],
    'lichtgrijs': ['light-grey', 'light-gray', 'lightgrey'],
    'donkergrijs': ['dark-grey', 'dark-gray', 'darkgrey'],
    'antraciet': ['charcoal', 'anthracite'],
    'marine': ['navy'],
    'marineblauw': ['navy'],
    'donkerblauw': ['dark-blue', 'darkblue', 'navy'],
    'blauw': ['blue'],
    'lichtblauw': ['light-blue', 'lightblue'],
    'groen': ['green'],
    'legergroen': ['army-green', 'armygreen', 'army'],
    'olijfgroen': ['olive'],
    'olijf': ['olive'],
    'kaki': ['khaki'],
    'bordeaux': ['burgundy', 'bordeaux', 'wine', 'maroon', 'red'],
    'rood': ['red'],
    'roze': ['pink', 'rose'],
    'lila': ['lilac'],
    'paars': ['purple'],
    'geel': ['yellow'],
    'oranje': ['orange'],
    'abrikoos': ['apricot'],
    'zilver': ['silver'],
    'goud': ['gold']
  };

  function ontdoe(s) {
    return (s || '').toLowerCase()
      .replace(/[àáâä]/g, 'a').replace(/[èéêë]/g, 'e').replace(/[ìíîï]/g, 'i')
      .replace(/[òóôö]/g, 'o').replace(/[ùúûü]/g, 'u');
  }

  function radios() {
    return document.querySelectorAll('variant-picker input[type=\"radio\"][data-option-name]');
  }

  /* De aangevinkte kleur uit de variantkiezer. */
  function gekozenKleur() {
    var alle = radios();
    for (var i = 0; i < alle.length; i++) {
      var naam = alle[i].getAttribute('data-option-name') || '';
      if (/kleur|colou?r/i.test(naam) && alle[i].checked) return alle[i].value;
    }
    return null;
  }

  /* Alle kleurnamen van dit product, langste eerst zodat "gebroken wit" voor
     "wit" gaat. */
  function alleKleuren() {
    var uit = [];
    var alle = radios();
    for (var i = 0; i < alle.length; i++) {
      var naam = alle[i].getAttribute('data-option-name') || '';
      if (/kleur|colou?r/i.test(naam) && uit.indexOf(alle[i].value) < 0) uit.push(alle[i].value);
    }
    return uit.sort(function (a, b) { return b.length - a.length; });
  }

  function noemtKleur(tekst, kleur) {
    var k = ontdoe(kleur).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp('(^|[^a-z])' + k + '([^a-z]|$)').test(ontdoe(tekst));
  }

  function altVan(li) {
    var img = li.querySelector('img');
    return img ? (img.getAttribute('alt') || '') : '';
  }

  /* De kale bestandsnaam uit een fotoadres, zonder map en zonder ?v=... */
  function basisVan(li) {
    var img = li.querySelector('img');
    if (!img) return '';
    var s = img.currentSrc || img.getAttribute('src') || '';
    return s.split('?')[0].split('/').pop();
  }

  /* ---- 1. de kleur uit de bestandsnaam -------------------------------- */

  /* Welke woorden horen bij deze kleurnaam? De naam zelf, de losse woorden
     erin, en de Engelse vertalingen uit het lijstje hierboven. Staat de naam
     er niet letterlijk in, dan kijken we of ze op een bekende kleur eindigt of
     ermee begint: Koffiebruin krijgt zo "brown" en "coffee" mee. */
  function tokensVoor(kleur) {
    var p = ontdoe(kleur);
    var kaal = p.replace(/[^a-z]/g, '');
    var uit = [];
    function voeg(t) { if (t && t.length > 2 && uit.indexOf(t) < 0) uit.push(t); }
    voeg(kaal);
    voeg(p.replace(/[^a-z]+/g, '-').replace(/^-|-$/g, ''));
    if (WOORDEN[kaal]) {
      for (var i = 0; i < WOORDEN[kaal].length; i++) voeg(WOORDEN[kaal][i]);
    } else {
      for (var sleutel in WOORDEN) {
        if (sleutel.length < 4 || kaal.length <= sleutel.length) continue;
        if (kaal.slice(-sleutel.length) === sleutel || kaal.slice(0, sleutel.length) === sleutel) {
          for (var s = 0; s < WOORDEN[sleutel].length; s++) voeg(WOORDEN[sleutel][s]);
        }
      }
    }
    var delen = p.split(/[^a-z]+/);
    for (var j = 0; j < delen.length; j++) {
      var d = delen[j];
      if (!d || d.length < 3) continue;
      voeg(d);
      if (WOORDEN[d]) {
        for (var k = 0; k < WOORDEN[d].length; k++) voeg(WOORDEN[d][k]);
      }
    }
    return uit;
  }

  /* bestandsnaam -> kleur, voor de foto's die hun kleur in hun naam dragen.
     null als er minder dan twee kleuren uit komen; een enkele treffer is
     meestal toeval en daar filteren we niet op. */
  function naamKaart(kleuren, namen) {
    var tel = {}, van = {};
    for (var i = 0; i < kleuren.length; i++) {
      var ts = tokensVoor(kleuren[i]);
      for (var j = 0; j < ts.length; j++) {
        tel[ts[j]] = (tel[ts[j]] || 0) + 1;
        van[ts[j]] = kleuren[i];
      }
    }
    /* Een woord dat twee kleuren van dit product noemt, zegt niets. */
    var lijst = [];
    for (var t in tel) { if (tel[t] === 1) lijst.push(t); }
    if (!lijst.length) return null;
    lijst.sort(function (a, b) { return b.length - a.length; });

    var kaart = {}, gezien = {}, aantal = 0;
    for (var n = 0; n < namen.length; n++) {
      var h = '-' + ontdoe(namen[n]).replace(/[^a-z0-9]+/g, '-') + '-';
      for (var q = 0; q < lijst.length; q++) {
        if (h.indexOf('-' + lijst[q] + '-') >= 0) {
          kaart[namen[n]] = van[lijst[q]];
          if (!gezien[van[lijst[q]]]) { gezien[van[lijst[q]]] = 1; aantal++; }
          break;
        }
      }
    }
    return aantal >= 2 ? kaart : null;
  }

  /* ---- 2. de kleur uit de positie ------------------------------------- */

  function leesData() {
    var el = document.getElementById('ai-kleurblokken-data');
    if (!el) return null;
    var d;
    try { d = JSON.parse(el.textContent); } catch (e) { return null; }
    if (!d || !d.ankers || !d.bestanden || !d.bestanden.length) return null;
    return d;
  }

  /* De blokken uitrekenen uit de ankers. Geeft een kaart bestandsnaam -> kleur,
     of null als de gegevens niet betrouwbaar genoeg zijn. */
  function blokKaart(d, kleuren) {
    var namen = d.bestanden;
    var ank = [];
    for (var i = 0; i < kleuren.length; i++) {
      var p = d.ankers[kleuren[i]];
      if (typeof p !== 'number' || p < 0 || p >= namen.length) return null;
      ank.push({ kleur: kleuren[i], pos: p });
    }
    ank.sort(function (a, b) { return a.pos - b.pos; });

    /* Twee kleuren op dezelfde foto: dan weten we het niet zeker genoeg. */
    var gaten = [];
    for (var j = 1; j < ank.length; j++) {
      var g = ank[j].pos - ank[j - 1].pos;
      if (g < 1) return null;
      gaten.push(g);
    }

    /* Het laatste blok heeft geen volgend anker om tegen af te lopen. Daarvoor
       nemen we de blokmaat die het vaakst voorkomt. Bij een product met zes
       foto's en zes kleuren is dat 1, bij het vest met blokken van vier is dat
       4 - en dan loopt het laatste blok netjes tot foto 19 in plaats van de
       hele staart op te slokken. */
    var telling = {}, maat = 1, beste = 0;
    for (var t = 0; t < gaten.length; t++) {
      telling[gaten[t]] = (telling[gaten[t]] || 0) + 1;
      if (telling[gaten[t]] > beste) { beste = telling[gaten[t]]; maat = gaten[t]; }
    }

    var kaart = {};
    for (var a = 0; a < ank.length; a++) {
      /* Het eerste blok begint bij foto 0, niet bij zijn eigen anker. Alles
         ervoor is onze eigen sfeerfoto, en die toont de eerste kleur. */
      var van = (a === 0) ? 0 : ank[a].pos;
      var tot = (a + 1 < ank.length) ? ank[a + 1].pos : Math.min(namen.length, ank[a].pos + maat);
      for (var q = van; q < tot && q < namen.length; q++) kaart[namen[q]] = ank[a].kleur;
    }
    return kaart;
  }

  /* ---- 3. de kleur uit de foto zelf ----------------------------------- */

  /* Hoeveel pixels van elke kleurtoon staan er in het midden van deze foto?
     Het midden, want daar staat het kledingstuk; de randen zijn achtergrond,
     haar en broek. 64 vakjes (vier stappen per kleurkanaal) is grof genoeg om
     licht- en schaduwverschillen te overbruggen en fijn genoeg om bruin van
     zwart te scheiden. Lukt het niet - de fotoserver geeft geen toestemming,
     bijvoorbeeld - dan geven we null terug en gebeurt er verder niets. */
  function meet(url) {
    return new Promise(function (ok) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.decoding = 'async';
      im.onload = function () {
        try {
          var w = 64;
          var h = Math.max(1, Math.round(w * (im.naturalHeight || 1) / (im.naturalWidth || 1)));
          var c = document.createElement('canvas');
          c.width = w; c.height = h;
          var x = c.getContext('2d');
          x.drawImage(im, 0, 0, w, h);
          var g = x.getImageData(
            Math.round(w * 0.2), Math.round(h * 0.25),
            Math.max(1, Math.round(w * 0.6)), Math.max(1, Math.round(h * 0.5))
          ).data;
          var H = [], i;
          for (i = 0; i < 64; i++) H[i] = 0;
          var n = 0;
          for (var p = 0; p < g.length; p += 4) {
            H[(g[p] >> 6) * 16 + (g[p + 1] >> 6) * 4 + (g[p + 2] >> 6)]++;
            n++;
          }
          if (!n) { ok(null); return; }
          for (i = 0; i < 64; i++) H[i] /= n;
          ok(H);
        } catch (e) { ok(null); }
      };
      im.onerror = function () { ok(null); };
      im.src = url;
    });
  }

  /* 0 = dezelfde kleurverdeling, 1 = niets gemeen. */
  function afstand(a, b) {
    var s = 0;
    for (var i = 0; i < 64; i++) s += Math.min(a[i], b[i]);
    return 1 - s;
  }

  /* Elke foto bij de variantfoto leggen die er het meest op lijkt. Alleen als
     die duidelijk dichterbij ligt dan de op een na dichtste; anders weten we
     het niet en blijft de foto bij elke kleur staan. */
  function staalKaart(d, kleuren, stalen) {
    var ank = [];
    for (var i = 0; i < kleuren.length; i++) {
      var p = d.ankers[kleuren[i]];
      if (typeof p !== 'number' || p < 0 || p >= stalen.length || !stalen[p]) return null;
      ank.push({ kleur: kleuren[i], s: stalen[p] });
    }
    if (ank.length < 2) return null;

    var kaart = {}, aantal = 0;
    for (var q = 0; q < stalen.length; q++) {
      var s = stalen[q];
      if (!s) continue;
      var beste = null, d1 = 9, d2 = 9;
      for (var a = 0; a < ank.length; a++) {
        var dd = afstand(s, ank[a].s);
        if (dd < d1) { d2 = d1; d1 = dd; beste = ank[a].kleur; }
        else if (dd < d2) { d2 = dd; }
      }
      if (beste && d1 < 0.75 && d1 <= 0.7 * d2) { kaart[d.bestanden[q]] = beste; aantal++; }
    }
    return aantal >= 2 ? kaart : null;
  }

  /* ---- de drie samenvoegen -------------------------------------------- */

  /* Spreken twee kaarten elkaar op MEERDERE foto's tegen? Een losse afwijking
     is ruis - een foto waar het kledingstuk klein in beeld staat. Drie of meer,
     en meer dan een op de zeven, is een patroon: dan deugt de tweede kaart
     niet. */
  function botst(a, b) {
    if (!a || !b) return false;
    var samen = 0, anders = 0;
    for (var k in a) {
      if (Object.prototype.hasOwnProperty.call(b, k)) {
        samen++;
        if (a[k] !== b[k]) anders++;
      }
    }
    return samen >= 4 && anders >= 3 && anders / samen > 0.15;
  }

  function bouwKaart() {
    var d = leesData();
    if (!d) return null;
    var kleuren = Object.keys(d.ankers);
    if (kleuren.length < 2) return null;       /* een kleur: niets te filteren */

    var naam = naamKaart(kleuren, d.bestanden);
    var blok = blokKaart(d, kleuren);
    if (botst(naam, blok) || botst(STAAL, blok)) blok = null;

    var uit = null;
    function leg(k) {
      if (!k) return;
      if (!uit) uit = {};
      for (var x in k) uit[x] = k[x];
    }
    /* Van achter naar voor in zekerheid: de meting vult aan waar de posities
       niets zeggen, de posities winnen van een losse misgemeten foto, en de
       bestandsnaam wint van allebei. */
    leg(STAAL);
    leg(blok);
    leg(naam);
    return uit;
  }

  /* De foto's op 64 pixels ophalen en meten. Dat duurt even, dus het filter
     draait eerst zonder; is het meten klaar, dan rekenen we opnieuw en
     filteren we nog eens. */
  function monsterLater() {
    var d = leesData();
    if (!d || !d.adressen || d.adressen.length !== d.bestanden.length) return;
    var kleuren = Object.keys(d.ankers);
    if (kleuren.length < 2) return;
    if (typeof Promise === 'undefined') return;

    var stalen = new Array(d.adressen.length);
    var open = d.adressen.length;

    function af() {
      if (--open > 0) return;
      var k = staalKaart(d, kleuren, stalen);
      if (!k) return;
      STAAL = k;
      BLOKKEN = bouwKaart();
      draai(true);
    }

    for (var i = 0; i < d.adressen.length; i++) {
      (function (n) {
        meet(d.adressen[n]).then(function (s) { stalen[n] = s; af(); });
      })(i);
    }
  }

  /* Bij welke kleur hoort deze foto? null = algemene foto, hoort bij alle. */
  function kleurVanFoto(li, kleuren) {
    if (BLOKKEN) {
      var b = basisVan(li);
      return Object.prototype.hasOwnProperty.call(BLOKKEN, b) ? BLOKKEN[b] : null;
    }
    /* Terugval: de kleurnaam uit de alt-tekst lezen, langste match eerst. */
    var alt = altVan(li);
    for (var k = 0; k < kleuren.length; k++) {
      if (noemtKleur(alt, kleuren[k])) return kleuren[k];
    }
    return null;
  }

  /* Een korte samenvatting van welke foto's er nu in de pagina staan. Verandert
     die, dan heeft het thema de galerij vernieuwd. Op bestandsnaam, want de
     alt-teksten zijn hier bij veel producten voor elke foto gelijk. */
  function inhoudVan(lijst) {
    var uit = [];
    for (var i = 0; i < lijst.length; i++) uit.push(basisVan(lijst[i]));
    return uit.join('|');
  }

  /* De foto's van een kleur alvast ophalen.

     Waarom dit moet: ons filter zet de foto's van de andere kleuren op
     display:none, en een verborgen foto met loading=\"lazy\" haalt de browser
     niet op. Wissel je dan van kleur, dan moet de eerste foto nog beginnen te
     laden terwijl ze al in beeld komt - en net dat zie je flikkeren. Het is
     dus een neveneffect van het filter zelf.

     Door de foto's op te halen zodra je een kleur AANWIJST of aanklikt, staan
     ze in de cache voor het thema de galerij vernieuwt (gemeten: dat gebeurt
     ruim zeshonderd milliseconden na de klik). Er wordt niets getoond of
     verplaatst; enkel opgehaald. */
  function voorladen(kleur) {
    if (!kleur || VOORGELADEN[kleur]) return;
    VOORGELADEN[kleur] = 1;

    var lijst = document.querySelectorAll('.product-media-container');
    var kleuren = alleKleuren();
    var gedaan = {};

    for (var i = 0; i < lijst.length; i++) {
      var img = lijst[i].querySelector('img');
      if (!img) continue;

      var van = kleurVanFoto(lijst[i], kleuren);
      /* Algemene foto's horen bij elke kleur en zijn er meestal al. */
      if (van !== null && van !== kleur) continue;

      var src = img.getAttribute('src');
      if (!src || gedaan[src]) continue;
      gedaan[src] = 1;

      var p = new Image();
      /* sizes en srcset meegeven, anders kiest de browser hier een andere
         maat dan ze straks nodig heeft en hebben we niets opgewarmd. */
      var sz = img.getAttribute('sizes');
      var ss = img.getAttribute('srcset');
      if (sz) p.sizes = sz;
      if (ss) p.srcset = ss;
      p.src = src;
    }
  }

  /* Welke foto's horen bij deze kleur? true = laten staan. */
  function watHouden(lijst, kleuren, kleur) {
    var houden = [];
    for (var i = 0; i < lijst.length; i++) {
      var van = kleurVanFoto(lijst[i], kleuren);
      houden.push(van === null || van === kleur);
    }
    return houden;
  }

  /* Staat de opmaak nog zoals wij ze gezet hebben?

     Dit is er bijgekomen met Horizon 4.3.0. Dat thema zet sindsdien bij ELKE
     variantwissel alle foto's weer zichtbaar, ook als je enkel een maat
     aanklikt. De kleur is dan niet veranderd en de foto's ook niet, dus aan
     die twee zagen we het niet: we sprongen er met een snelkoppeling uit en
     het filter bleef uit. Resultaat: alle tien de foto's terug en tien
     bolletjes onder een galerij waar er maar vier te zien waren.
     Daarom kijken we nu ook naar de opmaak zelf. */
  function klopt(lijst, houden) {
    for (var i = 0; i < lijst.length; i++) {
      if (lijst[i].classList.contains('ai-pp-weg') === houden[i]) return false;
    }
    return true;
  }

  function filterGalerij(forceer) {
    var lijst = document.querySelectorAll('.product-media-container');
    if (!lijst.length) return;

    var kleur = gekozenKleur();
    var kleuren = alleKleuren();
    if (!kleur || kleuren.length < 2) return; /* een kleur: niets te filteren */

    var inhoud = inhoudVan(lijst);
    var houden = watHouden(lijst, kleuren, kleur);

    if (!forceer && VORIGE_INHOUD !== null && inhoud === VORIGE_INHOUD && kleur === VORIGE_KLEUR) {
      WACHT_SINDS = null;
      if (klopt(lijst, houden)) return; /* niets veranderd */
      /* De opmaak is gewist door het thema: meteen terugzetten, niet wachten. */
    } else if (!forceer && VORIGE_INHOUD !== null && inhoud === VORIGE_INHOUD) {
      /* De kleur is gewisseld maar de galerij nog niet. Even wachten, anders
         filteren we de oude foto's op de nieuwe kleur en zie je een sprongetje.

         LET OP de deadline hieronder. Eerst startte ik die wachttijd telkens
         opnieuw bij elke beweging op de pagina. Staat de winkelwagen open, dan
         beweegt er om de paar tienden van een seconde iets, en kwam de noodrem
         dus nooit aan bod: je bleef alle kleuren door elkaar zien. Nu tellen we
         vanaf het moment dat we de wissel OPMERKTEN, zodat er hoe dan ook
         binnen 700 ms gefilterd wordt. */
      var nu = Date.now();
      if (WACHT_SINDS === null) WACHT_SINDS = nu;
      if (nu - WACHT_SINDS < 700) {
        clearTimeout(TIMER);
        TIMER = setTimeout(function () { draai(true); }, 700 - (nu - WACHT_SINDS));
        return;
      }
      /* Deadline verstreken: toch filteren, met de kleur die nu gekozen is. */
    }

    WACHT_SINDS = null;
    clearTimeout(TIMER);

    var i;
    if (houden.filter(Boolean).length === 0) return; /* vangnet: liever alles dan niets */

    for (i = 0; i < lijst.length; i++) {
      lijst[i].classList.toggle('ai-pp-weg', !houden[i]);
    }

    VORIGE_INHOUD = inhoud;
    VORIGE_KLEUR = kleur;
  }

  /* Pasadvies uit de eigen productbeschrijving, niet uit een vaste tekst. */
  function pasadvies() {
    var koppen = document.querySelectorAll('h3');
    for (var i = 0; i < koppen.length; i++) {
      if (!/^maten$/i.test(koppen[i].textContent.trim())) continue;
      var p = koppen[i].nextElementSibling;
      if (!p) continue;
      var t = p.textContent;
      /* Volgorde telt: \"slank; wil je het ruimer\" is slank, niet ruim. */
      if (/slank|slim|getailleerd/i.test(t)) return 'Valt slank';
      if (/ruim/i.test(t)) return 'Valt ruim';
      if (/valt normaal/i.test(t)) return 'Valt normaal';
      return null;
    }
    return null;
  }

  function zetPasadvies() {
    var advies = pasadvies();
    if (!advies) return;
    var alle = radios();
    for (var i = 0; i < alle.length; i++) {
      var naam = alle[i].getAttribute('data-option-name') || '';
      if (!/maat|size/i.test(naam)) continue;
      var veld = alle[i].closest('fieldset') || alle[i].closest('.variant-option');
      if (!veld) continue;
      var lg = veld.querySelector('legend');
      if (!lg || lg.querySelector('.ai-pp__pas')) return;
      var span = document.createElement('span');
      span.className = 'ai-pp__pas';
      span.textContent = advies;
      lg.appendChild(span);
      return;
    }
  }

  function draai(forceer) {
    if (BEZIG) return;
    BEZIG = true;
    try { filterGalerij(forceer === true); zetPasadvies(); } catch (e) { /* nooit de pagina breken */ }
    BEZIG = false;
  }

  /* Kies je een kleur, dan hertekent het thema de keuzeblokken en de galerij.
     Deze kijker zet onze aanpassingen meteen terug, nog voor de browser tekent. */
  function kijk() {
    if (KIJKER) return;
    KIJKER = new MutationObserver(function () { draai(false); });
    KIJKER.observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    if (!document.querySelector('variant-picker')) return;
    BLOKKEN = bouwKaart();
    draai(false);
    kijk();
    monsterLater();
    /* Wijs je een kleur aan, dan halen we haar foto's al op. Zo is de eerste
       foto meestal al binnen voor je klikt. */
    document.addEventListener('pointerover', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var lab = t.closest('variant-picker label');
      if (!lab) return;
      var inp = lab.control || document.getElementById(lab.getAttribute('for')) || lab.querySelector('input');
      if (!inp) return;
      if (/kleur|colou?r/i.test(inp.getAttribute('data-option-name') || '')) voorladen(inp.value);
    });

    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('variant-picker input[type=\"radio\"]')) {
        if (/kleur|colou?r/i.test(e.target.getAttribute('data-option-name') || '')) voorladen(e.target.value);
        setTimeout(function () { draai(false); }, 0);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
